import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { muiThemeV2 } from './muiTheme.js';

/**
 * ThemeProvider for v2 design system
 * Wraps children with MUI ThemeProvider using token-based theme configuration
 * 
 * Usage:
 * ```jsx
 * import { ThemeProvider } from './theme-v2/ThemeProvider';
 * 
 * function App() {
 *   return (
 *     <ThemeProvider>
 *       <YourComponents />
 *     </ThemeProvider>
 *   );
 * }
 * ```
 */
export default function ThemeProvider({ children })
{
    return (
        <MuiThemeProvider theme={muiThemeV2}>
            <CssBaseline />
            {children}
        </MuiThemeProvider>
    );
}
